"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteCqInvoker = void 0;
const cq_core_1 = require("@leavy/cq-core");
/**
 * Remote invoker that support commands and queries invocations by routing the invocation to the proper invoker.
 */
class RemoteCqInvoker {
    constructor(remoteCmdInvoker, remoteQueryInvoker) {
        this.remoteCmdInvoker = remoteCmdInvoker;
        this.remoteQueryInvoker = remoteQueryInvoker;
    }
    /**
     * Invoke remote procedure
     * @param invocationClass
     * @param invocationData
     * @param invokingContext
     */
    invokeResult(invocationClass, invocationData, invokingContext) {
        if (invocationClass.prototype instanceof cq_core_1.Command) {
            return this.remoteCmdInvoker.invokeResult(invocationClass, invocationData, invokingContext);
        }
        else if (invocationClass.prototype instanceof cq_core_1.Query) {
            return this.remoteQueryInvoker.invokeResult(invocationClass, invocationData, invokingContext);
        }
        throw new Error(`The given class ${invocationClass.name} is nor a command nor a query`);
    }
    /**
     * Execute method is a higher API method for invoking remote commands that will:
     * - Raise an exception on request or execution failures
     * - Raise an exception if the given command is not valid
     * - Return the ExecutionResult instead of the InvocationResult
     * @param type The command class
     * @param data The command data
     * @param context The invoking context
     */
    invoke(type, data, context) {
        if (type.prototype instanceof cq_core_1.Command) {
            return this.remoteCmdInvoker.invoke(type, data, context);
        }
        else if (type.prototype instanceof cq_core_1.Query) {
            return this.remoteQueryInvoker.invoke(type, data, context);
        }
        throw new Error(`The given class ${type.name} is nor a command nor a query`);
    }
}
exports.RemoteCqInvoker = RemoteCqInvoker;
//# sourceMappingURL=RemoteCqInvoker.js.map